import { JSONValue } from "@smile2impress/attraction-constants";

import {
    JSONSchemaServiceContentType,
    JSONSchemaServiceProps,
} from "./JSONSchemaService.types";
import { BlogJSONSchema, ProductJSONSchema, ClinicJSONSchema } from "./schemas";

export const generateJSONSchema = (
    data: JSONSchemaServiceProps
): JSONValue | null => {
    const { type, content } = data;

    switch (type) {
        case JSONSchemaServiceContentType.BLOG:
            return BlogJSONSchema(content);
        case JSONSchemaServiceContentType.PRODUCT:
            return ProductJSONSchema(content);
        case JSONSchemaServiceContentType.CLINIC:
            return ClinicJSONSchema(content);
        default:
            return null;
    }
};
